import { Injectable } from '@angular/core';
import { GeoJSON } from 'leaflet';
import {
  poiExportableValues,
  poiMarkdownValues,
} from '../../models/data-layer-type';
import { MarkdownService } from '../markdown.service';

@Injectable({
  providedIn: 'root',
})
export class PoiExportConverterService {
  constructor(private markdownService: MarkdownService) {}

  exportGeoJSONToExportArray(
    geoJSON: GeoJSON.FeatureCollection<
      GeoJSON.Point | GeoJSON.Polygon,
      GeoJSON.GeoJsonProperties
    >
  ): string[][] {
    const result: string[][] = [];
    geoJSON.features.forEach(feature => {
      const featureArray: string[] = [];
      for (const prop of poiExportableValues) {
        if (prop === 'coordinates') {
          featureArray.push(String(feature.geometry.coordinates[1]) ?? '');
          featureArray.push(String(feature.geometry.coordinates[0]) ?? '');
        } else if (poiMarkdownValues.includes(prop)) {
          featureArray.push(
            this.markdownService.convertToMarkdown(
              feature.properties?.[prop]
            ) ?? ''
          );
        } else {
          featureArray.push(feature.properties?.[prop] ?? '');
        }
      }
      result.push(featureArray);
    });
    return result;
  }
}
